import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { IconButton } from '@material-ui/core';
import Modal from '@material-ui/core/Modal';
import DateRangeIcon from '@material-ui/icons/DateRange';
import '../../App.css';
//Context
import { useReportes } from './ReportesContex';

const centered = {
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
};

const useStyles = makeStyles((theme) => ({
    paper: {
        ...centered,
        fontFamily: 'WorkSans',
        position: 'absolute',
        backgroundColor: theme.palette.background.paper,
        //border: '2px solid #000',
        boxShadow: theme.shadows[5],
        padding: '0px 0px 0px 0px',
    },
}));

const useStyles1 = makeStyles((theme) => ({
    paper: {
        ...centered,
        fontFamily: 'WorkSans',
        position: 'absolute',
        width: 1050,
        backgroundColor: theme.palette.background.paper,
        //border: '2px solid #000',
        boxShadow: theme.shadows[5],
        padding: '0px 0px 0px 0px',
    },
}));

function PopUp(props) {
    const { open, setOpen } = useReportes();
    const classes = useStyles();
    const classes1 = useStyles1();
    const selcClass = props.popupFlag ? classes1.paper : classes.paper;

    const handleOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const body = (
        <div className={selcClass}>
            <div id="simple-modal-title">{props.popupTitle}</div>
            <div id="simple-modal-description">{props.popupBody}</div>
        </div>
    );

    return (
        <div>
            <IconButton onClick={handleOpen}>
                <DateRangeIcon />
            </IconButton>
            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
            >
                {body}
            </Modal>
        </div>
    );
}

PopUp.defaultProps = {
    textButton: 'Agregar',
    colorButton: 'primary',
    popupTitle: 'Titulo',
    popupPrimButton: 'Aceptar',
    popupSeconButton: 'Cancelar',
    popupsbclass: 'popupbp',
    isContained: 'contained',
    isActive: true,
};

export default PopUp;
